<template>
	<div>
    	<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
    	<div class="d-flex justify-content-between align-items-center mb-3 rewardPoints" v-if="!transfetWallet">
	    	<h2 class="mb-0" >
	    		{{$t('loyalP_Reward_Points')}}
	    		<a :href="$env_var.websiteLink + $env_var.loyalty_pointLinl" class="green-color knowmore" target="_blank">{{$t('loyalP_Know_More')}}</a>
	    	</h2>
	    	<div class="d-flex pr-4">
	    		<a @click.prevent="transfetWallet = !transfetWallet" href="#" class="btn_xs  greenBG Redeem_btn">{{$t('loyalP_Trans_Wallet')}}</a>
		    </div>
    	</div>
    	<div class="row w-100" v-if="!transfetWallet">
    		<loyality-card-detail v-if="loyalityCardDetail.length > 0"></loyality-card-detail>
	        <redeam-point v-if="loyalityCardDetail.length > 0"></redeam-point>
	        <loyality-txn-list v-if="Object.keys(loyalityCardTxn).length > 0"></loyality-txn-list>
    	</div>
    	<div class="row" v-else>
	        <loyality-point-transfer ></loyality-point-transfer>
    	</div>
    </div>
</template>
<script>
	import loyality_card_detail from './loyality/loyality_card_detail'
	import loyality_txn_list from './loyality/loyality_txn_list'
	import loyality_point_transfer from './loyality/loyality_point_transfer'
	import redeam_point from './loyality/redeam-point'    
    export default {
        name: 'Wallet',
        data() {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,

                transfetWallet : false,
                nextLevel : '',
                nextLevelName : ''
            }
        },
		components:{
			LoyalityCardDetail: loyality_card_detail,
			LoyalityTxnList : loyality_txn_list,
			LoyalityPointTransfer : loyality_point_transfer,
			redeamPoint: redeam_point,
		},
		methods:{
			pointsCompletedFunc(){
				if(parseInt(this.loyalityCardDetail[0].issued_points) >= 1 && parseInt(this.loyalityCardDetail[0].issued_points) < 500){
					this.nextLevel = 500 - parseInt(this.loyalityCardDetail[0].issued_points)
					this.nextLevelName = 'SILVER'
					return '0'
				}else if(parseInt(this.loyalityCardDetail[0].issued_points) >= 500 && parseInt(this.loyalityCardDetail[0].issued_points) <= 5000){
					this.nextLevel = 5000 - parseInt(this.loyalityCardDetail[0].issued_points) 
					this.nextLevelName = 'GOLD'
					return '33.3'
				}else if(parseInt(this.loyalityCardDetail[0].issued_points) >= 5001 && parseInt(this.loyalityCardDetail[0].issued_points) < 20000){
					this.nextLevel = 20000 - parseInt(this.loyalityCardDetail[0].issued_points) 
					this.nextLevelName = 'DIAMOND'
					return '66.6'
				}else if(parseInt(this.loyalityCardDetail[0].issued_points) >= 20000){
					this.nextLevel = ''
					this.nextLevelName = ''
					return '99.9'
				}
			},
			cardDetailFunc(){
				this._runGetLoyalityCardDetail({'globalParams' : {},'localParams' : {'parameter' : this}})
			}
		},
		created(){
			this.cardDetailFunc()
		}
      
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/wallet/loyalty-points.vue